let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("UnQhJ")).then(() => parcelRequire('gUEw4'));